var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.36437 3.51728L7.36435 3.51739L7.37463 3.51909L8.96803 3.78329C8.96806 3.7833 8.96808 3.7833 8.96811 3.78331C9.38957 3.8536 9.4789 4.01125 9.49261 4.05438C9.50702 4.09966 9.52376 4.28449 9.21976 4.59344C9.21954 4.59367 9.21931 4.5939 9.21908 4.59413L7.97674 5.84479C7.79887 6.02385 7.68259 6.2605 7.61921 6.4838C7.55573 6.70749 7.52999 6.97175 7.58804 7.2221C7.58809 7.22232 7.58815 7.22254 7.5882 7.22277L7.94422 8.76961L7.94425 8.76972C8.07492 9.33684 7.92707 9.47848 7.92274 9.48166C7.92101 9.48294 7.74673 9.58342 7.25129 9.28591L7.25054 9.28547L5.75813 8.39282C5.52635 8.25234 5.25118 8.19836 5.00625 8.19836C4.76132 8.19836 4.48615 8.25234 4.25437 8.39282L2.76307 9.2848C2.76292 9.2849 2.76276 9.28499 2.7626 9.28508C2.26699 9.57964 2.09166 9.48069 2.08897 9.47873C2.08565 9.47629 1.93752 9.33709 2.06825 8.76972L2.06828 8.76961L2.42455 7.2217L2.42691 7.21144L2.42884 7.2011C2.47447 6.9561 2.44633 6.69744 2.38132 6.47472C2.31679 6.25361 2.20113 6.01756 2.02326 5.8385L0.77942 4.58632C0.475908 4.28078 0.493119 4.09766 0.507388 4.0528C0.521567 4.00822 0.612562 3.8499 1.03332 3.77678L2.62444 3.51295C2.62465 3.51292 2.62485 3.51288 2.62505 3.51285C2.85999 3.47422 3.08026 3.36011 3.2527 3.23098C3.42468 3.10219 3.59512 2.92396 3.69867 2.71143L4.57783 0.941292C4.57801 0.940934 4.57819 0.940576 4.57837 0.940218C4.7835 0.533139 4.96404 0.499913 4.99875 0.5C5.03388 0.500088 5.21564 0.534735 5.42132 0.945886C5.42141 0.946061 5.42149 0.946235 5.42158 0.94641L6.30134 2.71772C6.40577 2.93207 6.57766 3.10891 6.74888 3.23609C6.92164 3.36441 7.13763 3.47481 7.36437 3.51728Z",
    fill: "url(#paint0_radial_127_3037)",
    stroke: "#F1DF20"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_127_3037",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(4.75961 6.75) rotate(-112.737) scale(18.1613 33.7875)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.213331,
    stopColor: "#FAE123"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.798925,
    stopColor: "#FADD22",
    stopOpacity: 0.1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.09b2922cc1046c02912e17b3df786699.svg";
export { ForwardRef as ReactComponent };